import React from 'react';

const STEPS = [
  { title: 'Quote', text: 'Tell us what you want made — products, decoration, quantity and deadline. We reply within one business day. Low minimums.' },
  { title: 'Design & samples', text: 'We prepare your artwork for production and confirm colors, placements and details with you before anything is made.' },
  { title: 'Production', text: 'Your order is produced in-house at our LA / OC facilities. Typical turnaround is 7–10 days.' },
  { title: 'Quality check', text: 'Every order is checked before it leaves our facility.' },
  { title: 'Delivery & fulfillment', text: 'We ship nationwide, straight to you or wherever your merch needs to go.' },
];

export default function HowItWorks({ steps = STEPS, title = 'How it', accent = 'works', intro }) {
  return (
    <section className="relative bg-black py-24 md:py-32 border-t border-white/10" data-testid="how-it-works">
      <div className="max-w-[1500px] mx-auto px-6">
        <h2 className={`font-display text-[#f4efe6] uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight ${intro ? 'mb-6' : 'mb-16'}`}>
          {title} <span className="font-script text-[#00b8ff] normal-case italic">{accent}</span>
        </h2>
        {intro && <p className="text-[#cfc8bb] text-base md:text-lg max-w-3xl mb-14 leading-relaxed">{intro}</p>}
        <ol className={`grid gap-6 md:grid-cols-2 ${steps.length > 5 ? 'lg:grid-cols-4' : 'lg:grid-cols-5'}`}>
          {steps.map((s, i) => (
            <li key={s.title} className="relative rounded-xl border border-white/10 bg-white/[0.02] p-7 hover:border-[#00b8ff]/60 transition-colors duration-300" data-testid={`how-step-${i + 1}`}>
              <span className="font-display text-[#00b8ff] text-5xl leading-none">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="font-display text-[#f4efe6] uppercase text-2xl tracking-tight mt-6 mb-3">{s.title}</h3>
              <p className="text-[#cfc8bb] text-sm leading-relaxed">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
